import { useEffect, useState, useCallback } from 'react';

const KEY = 'sprite_vault_custom_v1';

const load = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) || [] : [];
  } catch (e) {
    return [];
  }
};

export function useCustomSprites() {
  const [sprites, setSprites] = useState(load);

  useEffect(() => {
    try {
      localStorage.setItem(KEY, JSON.stringify(sprites));
    } catch (e) {
      // ignore quota errors silently
    }
  }, [sprites]);

  const add = useCallback((sprite) => {
    const entry = {
      id: sprite.id || `cs-${Date.now()}`,
      name: sprite.name || 'Untitled Sprite',
      dataUrl: sprite.dataUrl,
      prompt: sprite.prompt || '',
      variant: sprite.variant || 'base',
      element: sprite.element || '',
      theme: sprite.theme || '',
      createdAt: new Date().toISOString(),
    };
    setSprites((prev) => [entry, ...prev]);
    return entry;
  }, []);

  const remove = useCallback((id) => {
    setSprites((prev) => prev.filter((s) => s.id !== id));
  }, []);

  const update = useCallback((id, patch) => {
    setSprites((prev) => prev.map((s) => (s.id === id ? { ...s, ...patch } : s)));
  }, []);

  const clear = useCallback(() => setSprites([]), []);

  return { sprites, add, remove, update, clear };
}
